// extracted by mini-css-extract-plugin
export default {"primaryFont":"LogoMobile_primaryFont__bTIcY","secondaryFont":"LogoMobile_secondaryFont__llpSr"};